<template>
  <div>
    <tabelas-header :title="nomeDoPlano"
      :mainMessage="itens.length > 0 ? `Valores com ${itens[0].PerCopart} de coparticipação` : ''"
      caption="Limite de Co-part:" :textComplementar="itens.length > 0 ? `\xa0${itens[0].ValorLimite} por item` : ''"
      :cardNumber="carteirinhaFormatada" :hasShowTable="isTable" :hasShowError="isError" :isLoading="isShowSkeleton" />
    <div class="buttons">
      <div class="pergunta-frequentes" v-if="isShowSkeleton">
        <div class="container card-header-title-coparticipacao" style="border: none; padding: 0;">
          <b-skeleton width="100%" height="40px"></b-skeleton>
        </div>
      </div>

      <div class="pergunta-frequentes" v-else :style="{ visibility: isShowTabela ? 'visible' : 'hidden' }">
        <a href="javascript:void(0)" @click.prevent="scrollToFaq" class="titulo-link-ancora">
          <div class="container card-header-title-coparticipacao">
            <img src="../assets/images/help.svg"></img>&nbsp;&nbsp;Perguntas
            frequentes sobre coparticipação
          </div>
        </a>
      </div>

      <div v-if="isShowSkeleton">
        <b-skeleton width="180px" height="20px"></b-skeleton>
      </div>
      <div v-else>
        <div class="outro-plano" @click="voltar"><img src="../assets/images/logout.svg"></img>Consultar outro plano
        </div>
      </div>
    </div>
    <div class="card-pesquisa" v-if="isShowSkeleton">
      <div class="card-container pesquisa-item d-flex align-items-center">
        <b-skeleton width="100%" height="45px"></b-skeleton>
      </div>
    </div>
    <div class="card-pesquisa" v-else-if="isTable">
      <div class="card-container pesquisa-item">
        <pesquisa placeHolder="Digite o código ou a descrição do item desejado" v-model="filtro"
          :click="filtrarTabela" />
      </div>
    </div>
    <div class="limitador-largura">
      <div class="acoes-tabela-container" v-if="isShowSkeleton">
        <div class="download-container">
          <b-skeleton type="button" width="40px" height="40px"></b-skeleton>
        </div>
        <b-skeleton width="520px" height="20px"></b-skeleton>
        <b-skeleton width="320px" height="20px"></b-skeleton>
      </div>

      <div class="acoes-tabela-container" v-else>

        <div class="download-container" v-if="isTable">
          <button class="btn-download" @click="baixarPDF"
            v-b-tooltip.hover.top.viewport="{ title: 'Baixar tabela PDF', customClass: 'download-tooltip', offset: [0, 18] }">
            <img :src="iconDownload" width="20" height="20" />
          </button>
        </div>

        <div class="container-informativo" v-if="!isShowMessage">
          <div class="aviso-informativo">Os valores apresentados já consideram o percentual de coparticipação previsto
            em seu contrato.</div>
          <div class="aviso-informativo">
            <span class="icone-alerta">
              <img :src="iconInfo" width="16" height="16" class="ml-auto" />
            </span>
            <span>
              Item pode ter acréscimo de <strong>Urgência e Emergência.</strong>
            </span>
            <a href="#" @click.prevent="scrollSaibaMais" class="link-saiba-mais">Saiba mais</a>
          </div>
        </div>

      </div>
    </div>

    <div class="card-tabelas">
      <b-skeleton-table class="table-skeleton" :columns="4" v-if="isShowSkeleton">
      </b-skeleton-table>
      <b-skeleton v-if="isShowSkeleton" class="block-skeleton" width="100%"></b-skeleton>
      <b-skeleton v-if="isShowSkeleton" class="block-skeleton" width="100%"></b-skeleton>
      <b-skeleton v-if="isShowSkeleton" class="block-skeleton" width="100%"></b-skeleton>
      <b-skeleton v-if="isShowSkeleton" class="block-skeleton" width="100%"></b-skeleton>
      <b-table id="tabelaCoparticipacao" striped hover stacked="md" :fields="fields" :items="filtrarTabela"
        :per-page="perPage" :current-page="currentPage" :skeleton-rows="true" fixed v-if="isShowTabela"
        class="table-responsive">
        <template #cell(ValorCopart)="data">
          <div class="d-flex align-items-center justify-content-between w-100">
            <span>{{ data.value }}</span>
            <template v-if="data.item.ExibeUrgencia">
              <img :src="iconInfo" width="16" height="16" class="ml-auto"
                v-b-tooltip.hover.top.viewport="{ title: `Valor Urgência e Emergência: ${data.item.ValorUrgEmerg}`, customClass: 'copart-tooltip' }" />
            </template>
          </div>
        </template>
      </b-table>
      <b-pagination v-if="rows > perPage" v-model="currentPage" class="custom-pagination" :per-page="perPage"
        :total-rows="rows" align="center" prev-text="Anterior" next-text="Próximo" limit="5" hide-ellipsis
        hide-goto-end-buttons>
      </b-pagination>
    </div>
    <faq-coparticipacao ref="faq" :is-show-button="isShowTabela" />
  </div>
</template>

<script>
import Pesquisa from "../components/pesquisa/Pesquisa";
import Header from "../components/header/Header.vue";

import { API_URL } from "../http/base-urls";
import axios from "../http/index.js";
import Faq from "../components/faq/Faq";
import provedor from "../http/provedor.js";
import imgInfo from "../assets/images/info.svg";
import imgDownload from "../assets/images/download.svg";
import { baixarPdfTabelaCoparticipacao } from "../utils/BaixarPdf";


export default {
  components: {
    Pesquisa,
    "tabelas-header": Header,
    "faq-coparticipacao": Faq,
  },
  data() {
    return {
      iconInfo: imgInfo,
      iconDownload: imgDownload,
      carteirinha: "",
      carteirinhaFormatada: "",
      filtro: "",
      rows: 0,
      perPage: 100,
      currentPage: 1,
      isShowTabela: false,
      isShowMessage: false,
      isShowSkeleton: true,
      isShowPagination: true,
      plano: null,
      nomeDoPlano: "",
      isUFSC: false,
      itens: [],
      fields: [
        {
          label: "Código",
          key: "CodItem",
          thStyle: { width: "10%" },
        },
        {
          label: "Tipo",
          key: "TipoItem",
          thStyle: { width: "20%" },
        },
        {
          label: "Descrição",
          key: "DescItem",
          thStyle: { width: "55%" },
        },
        {
          label: "Valor Co-part",
          key: "ValorCopart",
          thStyle: { width: "15%" },
        },
      ],
      isError: false,
      isTable: false,
    };
  },
  mounted() {
    const dadoSalvo = localStorage.getItem("Carteirinha");
    const carteirinhaOriginal = localStorage.getItem("CarteirinhaNaoUGF");

    if (dadoSalvo) {
      const numeroFormatado = JSON.parse(dadoSalvo);
      this.carteirinha = numeroFormatado.replace(/\D/g, "");

      if (carteirinhaOriginal) {
        this.carteirinhaFormatada = JSON.parse(carteirinhaOriginal);
        localStorage.removeItem("CarteirinhaNaoUGF");
      } else {
        this.carteirinhaFormatada = numeroFormatado;
      }
    }

    this.plano = JSON.parse(localStorage.getItem("Plano"));
    this.nomeDoPlano = (this.plano && this.plano.nome) ? this.plano.nome : "";
    this.isUFSC = this.plano && (this.plano.tabela === "UFSC" || this.plano === "ufsc");

    provedor.dispatch("autenticar").then(() => {
      const token = provedor.state.token;
      var config = {
        method: "get",
        url: `${API_URL}ObterTabelaCopart?tabela=${this.plano}&carteirinha=${this.carteirinha}`, //para teste local, colocar customer/, ex.: customer/obterTabelaCopart...
        headers: { Authorization: `Bearer ${token}` },
      };

      axios(config)
        .then((response) => {
          if (response.status === 200) {
            this.nomeDoPlano = this.formatarNomePlano(response.data[0].Tabela);
            this.isTable = true;
            this.itens = response.data;
            this.rows = this.itens.length;
            this.isShowTabela = true;
            this.isShowSkeleton = false;
          } else if (response.status === 204) {
            this.isShowTabela = false;
            this.isShowSkeleton = false;
          }

          this.isShowMessage = true;
        })
        .catch((error) => {
          this.isError = true;
          this.isShowMessage = false;
          this.isShowSkeleton = false;
          this.isShowTabela = false;
        });
    }).catch((error) => {
      this.isError = true;
      this.isShowSkeleton = false;
    });
  },
  computed: {
    filtrarTabela() {
      if (this.isShowSkeleton || !this.itens) return [];

      let itensFiltrado = [...this.itens];

      if (this.filtro) {
        const filtroTratado = this.filtro
          .trim()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
          .replace(/[-\s]+/g, "[\\s-]*");

        let exp = new RegExp(filtroTratado, "i");

        itensFiltrado = itensFiltrado.filter((tabela) => {
          const desc = String(tabela.DescItem || "")
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
          const cod = String(tabela.CodItem || "")
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/[^\w\s]/gi, "");
          return exp.test(desc) || exp.test(cod);
        });

        this.currentPage = 1;
      }

      itensFiltrado.sort((a, b) => {
        return a.DescItem.localeCompare(b.DescItem, 'pt-BR');
      });

      this.rows = itensFiltrado.length;
      this.isShowMessage =
        itensFiltrado.length < 1 &&
        (!this.isShowSkeleton || !this.isShowTabela);
      this.isShowTabela = !this.isShowMessage;

      return itensFiltrado;
    }
  },
  methods: {
    scrollToFaq() {
      const element = document.getElementById("ancora-faq");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
    scrollSaibaMais() {
      if (this.$refs.faq) {
        this.$refs.faq.abrirSecaoUrgencia();
      }
    },
    voltar() {
      this.$router.push({ name: "PesquisaTabelaCoparticipacao", query: { t: Date.now() } });
    },
    baixarPDF() {

      let itensParaExportacao = this.filtrarTabela;

      if (this.filtro && itensParaExportacao.length === 0 && this.itens.length > 0) {
        itensParaExportacao = this.itens;
      }

      baixarPdfTabelaCoparticipacao({
        itens: this.itens,
        itensParaExportar: itensParaExportacao,
        nomeDoPlano: this.nomeDoPlano,
        formattedCard: this.carteirinhaFormatada,

        carteirinha: this.carteirinha || this.carteirinhaFormatada
      });
    },
    formatarNomePlano(texto) {
      if (!texto) return "";

      const textoUpper = texto.toString().trim().toUpperCase();

      if (textoUpper.includes("LIGHT")) {
        return "Unimed Light";
      }

      if (textoUpper.includes("UNIFLEX") || textoUpper.includes("PERSONAL")) {
        return "Uniflex e Personal";
      }

      return textoUpper.replace(/[-/]/g, " ").trim();
    },
  },
};
</script>

<style scoped>
html {
  scroll-behavior: smooth;
}

a {
  text-decoration: none;
}

a,
a:active,
a:hover,
a:visited {
  color: var(--action-color);
  font-weight: bold;
}

.outro-plano {
  color: var(--color-brand-primary);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.1px;
  cursor: pointer;
}

.buttons {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  width: 918px;
  margin: 12px auto;
}

.card-header-title-coparticipacao {
  font-size: 14px;
  border: 1px var(--color-brand-primary) solid;
  padding: 9px 0 9px 0;
  border-radius: 5px;
  display: flex;
  align-items: center;
}

:target {
  scroll-margin-top: 0.12em;
}

.card-pesquisa {
  font-family: UnimedSans-Regular;
  display: flex;
  height: 100px;
  padding: 0 5%;
  background-color: var(--color-brand-primary);
}

.pesquisa-item {
  width: 100%;
}

.card-tabelas {
  margin: auto;
  padding-top: 20px;
}

.card-aviso-ufsc {
  margin: auto;
  padding-top: 10px;
}

.block-skeleton {
  height: 120px;
}

.table-skeleton /deep/ th {
  height: 36px;
  background-color: var(--color-brand-primary);
}

.table-skeleton /deep/ th:first-child {
  width: 10%;
}

.table-skeleton /deep/ th:nth-child(2) {
  width: 20%;
}

.table-skeleton /deep/ th:nth-child(3) {
  width: 55%;
}

.table-skeleton /deep/ th:nth-child(4) {
  width: 15%;
}

.table-skeleton /deep/ td div {
  width: 100%;
}

.table-skeleton /deep/ th .b-skeleton-text,
td .b-skeleton-text {
  height: 36px;
}

.mensagem {
  font-size: 24px;
  text-align: center;
  padding-bottom: 40px;
}

#tabelaCoparticipacao /deep/ thead {
  background-color: var(--color-brand-primary);
  border: none;
  color: var(--surface);
  font-family: "Trebuchet MS";
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
}

/deep/ .table {
  font-size: 13px;
}

/deep/ .table> :not(:first-child) {
  border: none;
}

/deep/ .table tbody tr td {
  font-family: "Trebuchet MS";
  border: none;
  color: var(--text-secondary);
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}

.custom-pagination /deep/ .page-item.active .page-link {
  color: var(--color-brand-primary);
  border-color: var(--border-subtle);
  background-color: var(--surface);
  font-weight: bold;
}

.custom-pagination /deep/ li.page-item.disabled span.page-link {
  color: var(--color-brand-primary);
}

.custom-pagination /deep/ .page-item .page-link {
  color: var(--color-brand-primary);
}

.container-informativo {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

@media (min-width: 0) {
  .buttons {
    flex-direction: column;
  }

  .table-skeleton {
    display: none;
  }

  .block-skeleton {
    display: block;
  }
}

@media (min-width: 768px) {
  .buttons {
    flex-direction: row;
  }
}

@media (min-width: 780px) {
  .card-tabelas {
    padding: 10px 5%;
  }

  .table-skeleton {
    display: inline-table;
  }

  .block-skeleton {
    display: none;
  }
}

@media (min-width: 992px) {

  .card-tabelas,
  .limitador-largura {
    padding: 10px 0;
    width: 920px;
  }

  .card-aviso-ufsc {
    padding: 10px 0;
    width: 920px;
  }
}

@media only screen and (min-device-width: 500px) and (max-device-width: 1840px) {
  .card-header-title-coparticipacao {
    justify-content: center;
    text-align: center;
    width: 500px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
    margin-bottom: 2%;
  }
}

@media only screen and (min-device-width: 281px) and (max-device-width: 500px) {
  .icone-interrogacao {
    margin: 4% 0 0 5%;
    padding: 1%;
  }

  .card-header-title-coparticipacao {
    justify-content: center;
    text-align: center;
    width: 350px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
    margin-bottom: 2%;
  }
}

@media only screen and (max-device-width: 280px) {
  .icone-interrogacao {
    margin: 4% 0 0 5%;
    padding: 1%;
  }

  .card-header-title-coparticipacao {
    display: flex;
    justify-content: center;
    text-align: center;
    width: 275px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
    margin-bottom: 2%;
  }
}

@media (min-width: 1280px) {
  .icone-interrogacao {
    margin: 4% 0 0 5%;
  }
}

@media only screen and (min-device-width: 1103px) and (max-device-width: 3400px) {
  .icone-interrogacao {
    margin: 0 0 0 5%;
    padding: 1%;
  }

  .card-header-title-coparticipacao {
    justify-content: center;
    text-align: center;
    width: 25em;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2%;
    margin-bottom: 2%;
  }
}

.aviso-informativo {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: var(--text-main);
}

.icone-alerta {
  display: flex;
  align-items: center;
}

.link-saiba-mais {
  color: var(--color-brand-primary);
  text-decoration: none;
  margin-left: 4px;
  font-weight: normal !important;
  padding: 2px 4px;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.link-saiba-mais:hover {
  background-color: var(--color-procedure-bg);
}

.btn-download {
  background-color: var(--surface);
  border: 1px solid var(--color-brand-primary);
  border-radius: 4px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.btn-download:hover {
  background-color: var(--border-subtle);
}

.limitador-largura {
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 14px;
}
</style>

<style>
.tooltip.bs-tooltip-top .arrow {
  position: absolute !important;
  bottom: 0 !important;
  display: block !important;
  width: 0.8rem !important;
  height: 0.4rem !important;
}

.tooltip.bs-tooltip-top .arrow::before {
  content: "" !important;
  position: absolute !important;
  border-style: solid !important;
  border-width: 0.4rem 0.4rem 0 !important;
  border-top-color: var(--text-primary) !important;
  border-right-color: transparent !important;
  border-left-color: transparent !important;
  border-bottom-color: transparent !important;
  left: 50% !important;
  margin-left: -0.4rem !important;
}

.tooltip-inner {
  background-color: var(--text-primary) !important;
  color: var(--surface) !important;
  border-radius: 4px !important;
  padding: 4px 8px !important;
}

.copart-tooltip .tooltip-inner {
  max-width: 350px;
  text-align: center;
}

.download-tooltip .tooltip-inner {
  min-height: 40px;
  display: flex;
  align-items: center;
}

.acoes-tabela-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 30px;
}

.download-container {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
</style>
